/**
 * Filter restaurants by user role.
 * Restaurant owners see only their restaurant; developers see their network's; admins see all.
 */
export function filterRestaurantsByUser<T extends { id: string; networkId?: string | null }>(
  restaurants: T[],
  user: { role?: string; restaurantId?: string | null; networkId?: string | null } | null
): T[] {
  if (!user) return restaurants;
  if (user.role === 'RESTAURANT_OWNER' && user.restaurantId) {
    return restaurants.filter((r) => r.id === user.restaurantId);
  }
  if (user.role === 'DEVELOPER' && user.networkId) {
    return restaurants.filter((r) => r.networkId === user.networkId);
  }
  return restaurants;
}
